exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification-bar[data-v-287047f4]{position:fixed;padding:1em 0;left:0;bottom:0;text-align:center;width:100%;z-index:99999}.notification-bar>div[data-v-287047f4]{width:33.33%;margin:0 auto;-webkit-box-shadow:0 2px 10px 0 rgba(0,0,0,.2);box-shadow:0 2px 10px 0 rgba(0,0,0,.2)}.notification-bar>div>div[data-v-287047f4]{padding:1em 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-287047f4","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Elements/Notification.vue
// module id = KwBq
// module chunks = 0